<template>
    <svg  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 255 180" :style="{'width' : width}">

        <!--<rect width="100%" height="100%" fill="#ccbadc "></rect>-->

        <g >

            <path class="animate letter" :stroke="p_color_s" d="M100,20
             l -90,0
             l 0,30
             l 30,0
             l 0,35
             l 15,15
             l 0,30
             m -15,-30
             l 0,50
             l 30,0
             l 0,-50
             l -15,-15
             m 0,-15
             l 0, -20
             l 0, 20
             l 15, 15
             l 0, -50
             l -45, 0
             l 75, 0
             l 0, 15
             l -15, 0">
            </path>

        </g>



        <g class="gLetter" >
            <path class="animate letter"
                  :stroke="p_color_s"
                  d="m200,40
                    m25,40
                    m-30,-60
                    l -50,0
                    l -20,20
                    l 10,10
                    l 15,-15
                    l 15,0
                    l 0,15
                    l -10,0
                    l -5,5">
            </path>
            <path   class="animate letter"
                    :stroke="p_color_s"
                    d=" m235,85
                        l -30,0
                        l 0,-15
                        l -20,-20
                        l -5,0
                        l 0,-15
                        l 10,0
                        l 30,30
                        l 0,5
                        l 15,0
                        l 0,-10
                        l -40,-40
                        l -10,0">
            </path>
            <path   class="animate letter"
                    :stroke="p_color_s"
                    d=" M140,65
                        l -5,5
                        l 0,15
                        l -15,0
                        l 0,-20
                        l 5,-5
                        l -10,-10
                        l -10,10
                        l 0,50
                        l 20,20
                        l 10,-10
                        l -15,-15
                        l 0,-5
                        l 15,0
                        l 20,20
                        l 15,0
                        ">
            </path>

            <path   class="letter animate"
                    :stroke="p_color_s"
                    d="m205,120
                    l 15,-15
                    l 0,-5
                    l 15,0
                    l 0,10
                    l -40,40
                    l -50,0
                    l -10,-10
                    l 10,-10
                    l 5,5
                    l 40,0
                    l 5,-5
                    l -10,-10
                    l 20,-20
                    ">
            </path>

            <path   class="letter animate"
                    :stroke="p_color_s"
                    d="m205,140
                        l 25,25
                        l 10,-10
                        l -15,-15
                        m 0, -20
                        l 25,25
                        ">
            </path>
        </g>

    </svg>

</template>

<script>
    export default {
        name: "si_Logo",
        props:{
            width:{
                type: String,
                default: "50px"
            },
            p_color_s:{
                type: String,
                default: "#501078"
            }
        }
    }
</script>

<style scoped>


    .letter{
        /*stroke:var(--color-purple);*/
        stroke-width:5;
        fill:none;
    }

    .animate {
        stroke-dasharray: 1000;
        stroke-dashoffset: 1000;
        animation: dash 5s linear alternate infinite;
    }

    @keyframes dash {
        to {
            stroke-dashoffset: 0;
        }
    }

</style>
